import $ from 'jquery';

/**
 * jQuery-ui plugin to turn a multiselect into a tree select field.
 *
 *     @example
 *     $('select#project_distributionLevels').treeSelect();
 *
 * @class jQuery.catalogFilter
 */
$.widget('ofcs.treeCopyMove', {
    widgetEventPrefix: 'copyMove',
    widgetBaseClass: 'ofcs-tree-copy-move',

    options: {
        currentParent: null,
        formInputId: null,
        source: null,
        requestLimit: 10,
        doneTypingInterval: 300,
        inputStyle: {},
        emptyText: 'Gibts nicht',
    },

    typingTimer: 0,
    getFilteredParents: undefined,

    /**
     * Initializes a new tree select instance
     */
    _create() {
        const { options } = this;
        const { keyCode } = $.ui;
        const { element } = this;
        this.formInput = $(options.formInputId);
        this._wrapper = $('<div tabindex="0" class="tree-select-wrapper copy-move"></div>');
        this._emptyPlaceholder = $('<li class="not-found"><a href=""></a></li>');
        const projects = [];

        this._wrapper.css(options.inputStyle);

        element.innerHTML = '';
        element.addClass(this.widgetBaseClass)
            .hide();

        this._emptyPlaceholder.children('a').text(options.emptyText);

        $(document).on('click', () => {
            setTimeout(() => {
                const isTreeSelect = $(document.activeElement).hasClass('cursor-aware');

                if (this._wrapper.hasClass('ui-state-focus') && !isTreeSelect) {
                    this._hideMenu();
                }
            }, 0);
        });

        this._on(this._wrapper, {
            'keydown .tag, .cursor-aware': (event) => {
                const elem = $(event.target);
                if (event.keyCode === keyCode.LEFT && (this._isCursorAtStart(event.target) || elem.is('.tag'))) {
                    const newElem = elem.prev();
                    if (newElem.length) {
                        newElem.trigger('focus');
                        this._moveCursorToEnd(newElem[0]);
                    }
                } else if (event.keyCode === keyCode.RIGHT && (this._isCursorAtEnd(event.target) || elem.is('.tag'))) {
                    elem.next().trigger('focus');
                }
            },
            'keydown .tag': (event) => {
                if (event.keyCode === keyCode.BACKSPACE || event.keyCode === keyCode.DELETE) {
                    const tag = $(event.target);
                    const nextAware = tag.next('.cursor-aware');

                    this._removeTag(tag);

                    nextAware.trigger('focus');
                    event.preventDefault();
                }
            },
            'keydown .cursor-aware': '_onCursorAwareKeyDown',
            'keyup .cursor-aware': '_onCursorAwareKeyUp',
            mousedown(event) {
                if (event.target === this._wrapper[0]) {
                    const elem = this._wrapper.children('.cursor-aware:last');
                    elem.trigger('focus');
                    this._moveCursorToEnd(elem[0]);
                    this._showMenu();
                    event.preventDefault();
                }
            },
            focus(event) {
                this._wrapper.children('.cursor-aware:last').trigger('focus');
                event.preventDefault();
            },
            'mousedown .tag': (event) => {
                $(event.target).trigger('focus');
            },
            'click .tag .remove': (event) => {
                const tag = $(event.target).parent();
                const nextAware = tag.next('.cursor-aware');

                this._removeTag(tag);
                nextAware.trigger('focus');
                event.preventDefault();
            },
            'focus .cursor-aware, .tag': (event) => {
                const elem = $(event.target);

                // This fixes the order of blur and focus events
                if (document.activeElement !== event.target) {
                    $(document.activeElement).blur();
                }

                if (elem.is('.cursor-aware')) {
                    this._currentCursorAware = $(event.target);
                }
                this._wrapper.addClass('ui-state-focus')
                    .attr('tabindex', '-1');
            },
            'focusout .cursor-aware, .tag': () => {
                setTimeout(() => {
                    const focusedElement = document.activeElement.nodeName;

                    if (focusedElement === 'UL') {
                        return;
                    }

                    this._wrapper
                        .removeClass('ui-state-focus')
                        .attr('tabindex', '0');
                    this._hideMenu();
                }, 0);
            },
        });

        if (options.currentParent) {
            const { currentParent } = options;
            const initialTag = $('<option></option>').attr('value', currentParent.id).text(currentParent.title);

            if (initialTag) {
                this._addTag(initialTag);
            }
        }

        this._wrapper.insertAfter(element);

        element.children().each((index, child) => {
            const option = {};
            const $child = $(child);

            option.asParentAllowed = $child.data('allowed');
            option.id = $child.data('parent');
            option.level = $child.data('level');
            option.title = $child.text();
            option.type = $child.data('listtype');

            projects.push(option);
        });

        this._initMenu(projects);
        this._ensureCursorAwares();

        if (this.formInput.setValidationTarget) {
            this.formInput.setValidationTarget(this._wrapper);
        } else {
            this.formInput.data('validation-target', this._wrapper);
        }
    },

    /**
     * Initializes a new menu based on the options of the multi select
     *
     * @param {Array} data
     * @private
     */
    _initMenu(data) {
        const wrapper = this._wrapper;
        const menu = $('<ul />');
        this._items = [];
        const elemsToIds = {};

        this._addChildren(menu, data);

        this._items.forEach((item) => {
            const parentId = item.data('parent-id');
            if (parentId) {
                elemsToIds[parentId].data('children').push(item);
            }
        });

        menu.on('menuselect', (event, ui) => this._onMenuSelect(data, event, ui));

        menu.menu()
            .insertAfter(wrapper);

        this._menu = menu.data('uiMenu');
    },

    _onMenuSelect(data, event, ui) {
        const { item } = ui;
        const id = item.data('id');
        const elem = this.element;
        const optionElem = elem.children(`[value=${id}]`);
        const selected = [];

        this._hideMenu();

        selected.push(id);
        elem.val(selected);
        elem.trigger('change');

        this._wrapper.children('.tag').remove();

        this.formInput.val(selected).trigger('change');

        const tag = this._addTag(optionElem, this._currentCursorAware);

        this._ensureCursorAwares();
        tag.next('.cursor-aware').trigger('focus');

        event.preventDefault();
    },

    _addTag(option, replace) {
        const tag = $(`
            <span class="tag badge" data-id="" tabindex="-1">
                <span class="text"></span>
                <i class="remove icon-remove"></i>
            </span>
        `);
        const wrapper = this._wrapper;

        const $option = $(option);

        tag.attr('data-id', $option.attr('value'))
            .children('.text')
            .text(this._cleanupOptionText($option.text()));

        if (replace && replace.length > 0) {
            replace.replaceWith(tag);
        } else {
            tag.appendTo(wrapper);
        }

        return tag;
    },

    _removeTag(tag) {
        const elem = this.element;
        const id = tag.data('id');
        const values = elem.val();
        const valuesWithoutTag = values && $.grep(values, value => value !== id);

        elem.val(valuesWithoutTag);
        elem.trigger('change');

        tag.prev('.cursor-aware').remove();
        tag.remove();

        this.formInput.val('').trigger('change');

        this._ensureCursorAwares();
    },

    _ensureCursorAwares() {
        const inputTemplate = '<div class="cursor-aware" tabindex="-1" contenteditable />';
        const wrapper = this._wrapper;

        if (!wrapper.children(':first').is('.cursor-aware')) {
            wrapper.prepend(inputTemplate);
        }

        wrapper.children('.tag').each((index, element) => {
            if (!$(element).next().is('.cursor-aware')) {
                $(inputTemplate).insertAfter(element);
            }
        });
    },

    _showMenu() {
        const menu = this._menu;
        const elem = menu.element;

        if (!elem.is(':visible')) {
            elem.show();
            elem.scrollTop(0);
        }

        this._positionMenu();
        this._isAllowed(elem.children());
        this._ensureActiveMenuItem();
    },

    _hideMenu() {
        const menu = this._menu;
        menu.element.hide();
    },

    _positionMenu() {
        this._menu.element.position({
            my: 'left top-2',
            at: 'left bottom',
            of: this._wrapper,
        });
    },

    /**
     * Sets the cursor position to the end of the given content editable.
     * This solution comes from [StackOverflow][1].
     *
     * [1]: http://stackoverflow.com/questions/1125292/how-to-move-cursor-to-end-of-contenteditable-entity#3866442
     *
     * @param {Node} elem
     * @private
     */
    _moveCursorToEnd(elem) {
        if (document.createRange) {
            // Firefox, Chrome, Opera, Safari, IE 9+
            const range = document.createRange();// Create a range (a range is a like an invisible selection)
            range.selectNodeContents(elem);// Select the entire contents of the element with the range
            range.collapse(false);// collapse the range to the end point. false means collapse to end rather than start
            const selection = window.getSelection();// get the selection object (allows you to change selection)
            selection.removeAllRanges();// remove any selections already made
            selection.addRange(range);// make the range you have just created the visible selection
        } else if (document.selection) {
            // IE 8 and lower
            const range = document.body.createTextRange();// Create a range (a range is a like an invisible selection)
            range.moveToElementText(elem);// Select the entire contents of the element with the range
            range.collapse(false);// collapse the range to the end point. false means collapse to end rather than start
            range.select();// Select the range (make it the visible selection
        }
    },

    _getCursorPosition(elem) {
        if (window.getSelection) {
            const sel = window.getSelection();
            if (sel.rangeCount) {
                const range = sel.getRangeAt(0);
                if (range.commonAncestorContainer === elem
                    || range.commonAncestorContainer.parentNode === elem) {
                    return range.endOffset;
                }
            }
        } else if (document.selection && document.selection.createRange) {
            const range = document.selection.createRange();
            if (range.parentElement() === elem) {
                const tempEl = document.createElement('span');
                elem.insertBefore(tempEl, elem.firstChild);
                const tempRange = range.duplicate();
                tempRange.moveToElementText(tempEl);
                tempRange.setEndPoint('EndToEnd', range);
                return tempRange.text.length;
            }
        }

        return -1;
    },

    _isCursorAtStart(elem) {
        return this._getCursorPosition(elem) === 0;
    },

    _isCursorAtEnd(elem) {
        return this._getCursorPosition(elem) === $(elem).text().length;
    },

    _cleanupOptionText(text) {
        const matches = text?.trim().match(/^-*(.*)$/);
        return matches ? matches[1] : text;
    },

    _onCursorAwareKeyDown(event) {
        const { keyCode } = $.ui;
        const menu = this._menu;
        const elem = $(event.target);
        const currentTag = this._wrapper.children('.tag');

        if (currentTag[0] && !keyCode.ENTER) {
            this._removeTag(currentTag);
        }

        switch (event.keyCode) {
            case keyCode.UP:
                menu.previous(event);
                event.preventDefault();
                break;
            case keyCode.DOWN:
                if (menu.element.is(':visible')) {
                    menu.next(event);
                } else {
                    this._showMenu();
                }
                event.preventDefault();
                break;
            case keyCode.TAB:
                if (menu.element.is(':visible')) {
                    event.preventDefault();
                    if (menu.active && !menu.active.is('.ui-state-disabled')) {
                        menu.select(event);
                    }
                }
                break;
            case keyCode.ENTER:
                if (menu.active && !menu.active.is('.ui-state-disabled')) {
                    menu.select(event);
                } else {
                    $('.modal-footer .btn-primary', window.currentModal.modalElement).trigger('click');
                }
                event.preventDefault();
                break;
            case keyCode.BACKSPACE:
                if (elem.text() === '') {
                    elem.prev().trigger('focus');
                    event.preventDefault();
                }
                break;
            case keyCode.DELETE:
                if (elem.text() === '') {
                    elem.next().trigger('focus');
                    event.preventDefault();
                }
                break;
            case keyCode.ESCAPE:
                this._hideMenu();
                break;
            case keyCode.LEFT:
            case keyCode.RIGHT:
            case keyCode.SHIFT:
            case keyCode.HOME:
            case keyCode.END:
            case 16: // shift
                // Do nothing
                break;
            default:
                this._showMenu();
                break;
        }
    },

    _onCursorAwareKeyUp(event) {
        const { keyCode } = $.ui;

        if (event.keyCode !== keyCode.UP
            && event.keyCode !== keyCode.DOWN
            && event.keyCode !== keyCode.ENTER) {
            this._positionMenu();
            this._ensureActiveMenuItem();

            clearTimeout(this.typingTimer);

            if (this.getFilteredParents !== undefined) {
                this.getFilteredParents.abort();
            }

            this.typingTimer = setTimeout(() => {
                this._filterMenu();
            }, this.options.doneTypingInterval);
        }
    },

    _filterMenu(searchText) {
        const menu = this._menu;
        const menuEl = menu.element;
        const { source, requestLimit } = this.options;
        let text = searchText || this._currentCursorAware.text() || '';
        text = typeof text === 'string' ? encodeURI(text.toLowerCase()) : '';

        const search = text ? `${source}?term=${text}&limit=${requestLimit}` : source;

        this.getFilteredParents = $.get(search);

        this.getFilteredParents.done((result) => {
            this.element.empty();

            result.forEach((option) => {
                if (option.asParentAllowed) {
                    const optionEl = $('<option></option>').attr('value', option.id).text(option.title);
                    this.element.append(optionEl);
                }
            });

            this._updateMenu(result);
        });

        if (menuEl.children().length === 0) {
            menuEl.append(this._emptyPlaceholder.addClass('ui-state-disabled'));
        }
    },

    /**
     * @param {Array} children
     * @private
     */
    _updateMenu(children) {
        const menu = this._menu.element;
        menu.off('menuselect');

        menu.children().remove();

        if (children.length < 1) {
            menu.append(this._emptyPlaceholder.addClass('ui-state-disabled'));
            return;
        }

        this._addChildren(menu, children);

        this._isAllowed(menu.children());

        menu.on('menuselect', (event, ui) => this._onMenuSelect(children, event, ui));

        menu.menu('refresh')
            .insertAfter(this._wrapper);

        this._menu = menu.data('uiMenu');
    },

    /**
     * @param {Node} menuEl
     * @param {Array} data
     * @private
     */
    _addChildren(menuEl, data) {
        this._elemsToIds = {};

        data.forEach((option) => {
            const elem = $('<li class="elem"></li>');
            const { id } = option;
            const text = this._cleanupOptionText(option.title);
            const link = $('<a href=""></a>');

            link.text(text)
                .css('padding-left', option.level * 15 + 20);

            const linkCls = id === this.formInput.val() ? 'icon-ok' : 'icon-caret-right';

            link.prepend(`<i class="icon ${linkCls}"></i>`);

            elem.data({
                'parent-id': option.parent,
                id,
                text: text.toLowerCase(),
                allowed: option.asParentAllowed,
                children: [],
            })
                .append(link);

            this._items.push(elem);
            this._elemsToIds[id] = elem;

            menuEl.append(elem);
        });
    },

    /**
     * @param {Array<jQuery>} items
     * @private
     */
    _isAllowed(items) {
        items.each((item) => {
            const $item = $(item);

            if ($item.data('allowed')) {
                $item.removeClass('ui-state-disabled');
            } else {
                $item.addClass('ui-state-disabled');
            }
        });
    },

    _ensureActiveMenuItem() {
        const menu = this._menu;
        const items = menu.element.children();
        const { active } = menu;
        const currentText = this._currentCursorAware.text();

        if (currentText === '') {
            menu.blur();
        } else if (!active || active.is('.ui-state-disabled') || items.index(active) === -1) {
            const nextActive = items.filter(':not(.ui-state-disabled):first');
            if (nextActive.length) {
                menu.focus(null, nextActive);
            } else {
                menu.blur();
            }
        }
    },

    _destroy() {
        this._wrapper.remove();
        this.element.show();
    },
});
